<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>


    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="询价信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">活动名称：</td>
                  <td class="data">
                    {{this.form.activityName}}
                  </td>
                </tr>
                <tr>
                  <td class="first">开始时间：</td>
                  <td class="data">
                    {{this.form.startTime}}
                  </td>
                  <td class="first">结束时间：</td>
                  <td class="data">
                    {{this.form.endTime}}
                  </td>
                </tr>
                <tr>
                  <td class="first">最晚交期：</td>
                  <td class="data">
                    {{this.form.deliveryTime}}
                  </td>
                  <td class="first">是否需要缴纳保证金：</td>
                  <td class="data">
                    <span v-if="form.payBond == 0">
                      否
                    </span>
                    <span v-if="form.payBond == 1">
                      是
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="first">保证金金额：</td>
                  <td class="data">
                    {{this.form.bondMoney}}
                  </td>
                  <td class="first">底价：</td>
                  <td class="data">
                    {{this.form.endMoney}}
                  </td>
                </tr>
                <tr>
                  <td class="first">付款方式：</td>
                  <td class="data">
                     <span v-if="form.payType == 10">
                      现金支付
                    </span>
                    <span v-if="form.payType == 20">
                      线上转账
                    </span>
                  </td>
                  <td class="first">是否上架：</td>
                  <td class="data">
                    <span v-if="form.isSell == 0">
                      否
                    </span>
                    <span v-if="form.isSell == 1">
                      是
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="first">物流方式：</td>
                  <td class="data">
                     <span v-if="form.expressType == 10">
                      同城快运
                    </span>
                  </td>
                  <td class="first">询价状态：</td>
                  <td class="data">
                    <span v-if="form.status == 10">
                      预告
                    </span>
                    <span v-if="form.status == 20">
                      进行中
                    </span>
                    <span v-if="form.status == 30">
                      已结束
                    </span>
                    <span v-if="form.status == 40">
                      已开标
                    </span>
                  </td>
                </tr>

              </table>
            </a-card>
          </td>
        </tr>
      </table>
    </div>

    <div v-if="form.status == 30 || form.status == 40" style="margin-top: 50px;">
      <a-card  :bordered="false" title="中标人信息"
               :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
               :bodyStyle="{'background-color':'#fbfbfb'}">
      </a-card>
      <a-table
        :size="tableSize"
        rowKey="id"
        :columns="bidcolumnscol"
        :data-source="form.bigUserList"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="bidpicture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;"  alt="none"/>
          </div>
        </template>
        <template slot="bidavatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;"  alt="none"/>
          </div>
        </template>
      </a-table>
    </div>

    <div style="margin-top: 50px;">
      <a-card  :bordered="false" title="询价商品信息"
               :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
               :bodyStyle="{'background-color':'#fbfbfb'}">
      </a-card>
        <a-table
          :loading="loading"
          :size="tableSize"
          @change="handleSortChange"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;"  alt="none"/>
            </div>
          </template>

      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </div>

    <div style="margin-top: 50px;">
      <a-card  :bordered="false" title="报价人信息"
               :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
               :bodyStyle="{'background-color':'#fbfbfb'}">
      </a-card>
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="bidcolumns"
        :data-source="bidlist"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;"  alt="none"/>
          </div>
        </template>

        <span slot="bidStatus" slot-scope="text, record">
           <span v-if="record.bidStatus == '10'">
             待开标
           </span>
           <span v-if="record.bidStatus == '20'">
             已中标
           </span>
           <span v-if="record.bidStatus == '30'">
             未中标
           </span>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="zhongbiao(record)" v-if="form.status==20 || form.status==30">
            <a-icon type="edit" />中标
          </a>
        </span>

      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="bidqueryParam.pageNum"
        :total="bidtotal"
        :page-size="bidqueryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </div>

    <div style="margin-top: 120px;">
      <div class="bottom-control">
        <a-space>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </div>
  </a-drawer>

</template>

<script>

import {
  getActivityXunjia,
  addActivityXunjia,
  updateActivityXunjia,
  pageActivityXunjia,
  goodspageActivityXunjia,
  goodspage,
  bigpage,
  zhongbiao,
  chujia
} from '@/api/activityXunjia/activityXunjia'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateRdStr, uploadObject, uploadOss} from "@/api/tool/oss";
import {allBrand} from "@/api/goods/brand";
import {listCategory} from "@/api/goods/category";
import Editor from "@/components/Editor/Editor";
import {translation} from "@/api/tool/common";

import { tableMixin } from '@/store/table-mixin'
import {listType} from "@/api/activity/type";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list:[],
      pageSizeOptions: ['10', '20', '50', '100'],
      queryParam: {
        activityId: undefined,
        activityName: undefined,
        startTime: undefined,
        endTime: undefined,
        deliveryTime: undefined,
        payBond: undefined,
        bondMoney: undefined,
        endMoney: undefined,
        isSell: undefined,
        payType: undefined,
        expressType: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      columns: [
        {
          title: this.$t('商品.商品名称'),
          dataIndex: 'goodsName',
          width: 200,
        },
        {
          title: this.$t('商品.商品分类'),
          dataIndex: 'categoryName',
          width: 200,
        },
        {
          title: this.$t('商品.品牌'),
          dataIndex: 'brandName',
          width: 200,
        },
        {
          title: this.$t('商品.商品主图'),
          dataIndex: 'picture',
          width: 200,
          scopedSlots: {customRender: 'picture'},
        },
      ],
      bidcolumnscol:[
        {
          title: this.$t('用户昵称'),
          dataIndex: 'nickName',
          width: 150,
        },
        {
          title: this.$t('手机号码'),
          dataIndex: 'phoneNumber',
          width: 100,
        },
        {
          title: this.$t('头像'),
          dataIndex: 'avatar',
          width: 100,
          scopedSlots: {customRender: 'bidavatar'},
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 200,
        },
        {
          title: this.$t('商品图片'),
          dataIndex: 'picture',
          width: 100,
          scopedSlots: {customRender: 'bidpicture'},
        },
        {
          title: this.$t('报价金额'),
          dataIndex: 'quoMoney',
          width: 100,
        },
        {
          title: this.$t('交付时间'),
          dataIndex: 'deliverDate',
          width: 150,
        },
      ],
      //报价人列表
      bidlist:[],
      bidtotal: 0,
      bidcolumns: [
        {
          title: this.$t('出价人昵称'),
          dataIndex: 'nickName',
          width: 150,
        },
        {
          title: this.$t('出价人头像'),
          dataIndex: 'avatar',
          width: 100,
          scopedSlots: {customRender: 'avatar'},
        },
        {
          title: this.$t('出价人手机号'),
          dataIndex: 'phoneNumber',
          width: 100,
        },
        {
          title: this.$t('报价金额'),
          dataIndex: 'quoMoney',
          width: 100,
        },
        {
          title: this.$t('交付时间'),
          dataIndex: 'deliverDate',
          width: 150,
        },
        {
          title: this.$t('中标状态'),
          dataIndex: 'bidStatus',
          width: 100,
          scopedSlots: {customRender: 'bidStatus'},
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      bidqueryParam: {
        activityId: undefined,
        activityName: undefined,
        startTime: undefined,
        endTime: undefined,
        deliveryTime: undefined,
        payBond: undefined,
        bondMoney: undefined,
        endMoney: undefined,
        isSell: undefined,
        payType: undefined,
        expressType: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      },

      errorMessage:undefined,

      activityTypeList:[],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      brandList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: false,
      // 表单参数
      form: {
        goodsList:[],
        localeList: [],

        id: null,

        activityName: null,

        startTime: null,

        endTime: null,

        deliveryTime: null,

        payBond: null,

        bondMoney: null,

        endMoney: null,

        isSell: null,

        payType: null,

        expressType: null,

        status: 0,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {

      }
    }
  },
  filters: {
  },
  created () {
    this.getBrandList();
    this.getCateList();
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        localeList: [],
        goodsList:[],
        id: null,
        activityName: null,
        startTime: null,
        endTime: null,
        deliveryTime: null,
        payBond: null,
        bondMoney: null,
        endMoney: null,
        isSell: null,
        payType: null,
        expressType: null,
        status: 0,
        sort: null,
        createTime: null,
        remark: null,
      }
    },

    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },

    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
        const cate = { id: "0", categoryName: this.$t('通用.文本.根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id','pid')
        this.cateOptions.push(cate)
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    indexGoodsModalSelect(records) {
      this.form.goodsList = records
      console.log('商品选择了',this.form.goodsList)
    },
    openProdSelect() {
      this.$refs.CheckboxGoodsSelectForm.openGoods(undefined, this.form.goodsList, 10);
    },


    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'coverPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'posterPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // oss 上传结束

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true

      this.formTitle = this.$t('通用.文本.添加')
    },


    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.open = true
      this.formTitle = '详情'

      //查询询活动详情
      this.getActivityDetail(id);



      this.queryParam.activityId = id;
      this.bidqueryParam.activityId = id;
      //查询询价商品列表数据
      this.getList();
      //查询询价报价人列表数据
      this.getBidList();
    },
    /** 提交按钮 */
    submitForm: function () {
      // let localeValid = this.validatorLocaleName();
      // if (!localeValid) {
      //   return false;
      // }
      // if (this.form.goodsList.length === 0) {
      //   this.$message.error('请选择商品', 3)
      //   return false;
      // }
      // this.$refs.form.validate(valid => {
      //   if (valid) {
      //     this.submitLoading = true
      //     let message = '';
      //     if (this.form.id !== undefined && this.form.id !== null) {
      //       message = this.$t('通用.文本.修改成功')
      //       updateActivityXunjia(this.form).then(response => {
      //         this.$message.success(
      //           message,
      //           3
      //         )
      //         this.open = false
      //         this.$emit('ok')
      //       }).finally(() => {
      //         this.submitLoading = false
      //       })
      //     } else {
      //       message = this.$t('通用.文本.修改成功')
      //       addActivityXunjia(this.form).then(response => {
      //         this.$message.success(
      //           message,
      //           3
      //         )
      //         this.open = false
      //         this.$emit('ok')
      //       }).finally(() => {
      //         this.submitLoading = false
      //       })
      //     }
      //   } else {
      //     return false
      //   }
      // });
    },

    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    getActivityDetail(id){
      getActivityXunjia({"id":id}).then(response => {
        this.form = response.data
      })
    },

    /** 查询询价商品列表 */
    getList () {
      this.loading = true
      goodspage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询询价报价人列表 */
    getBidList () {
      this.loading = true
      bigpage(this.bidqueryParam).then(response => {
        this.bidlist = response.data.records
        this.bidtotal = response.data.total
        this.loading = false
      })
    },
    /** 中标 */
    zhongbiao(record){
      let message = "中标成功";
      zhongbiao(record).then(response => {
        this.$message.success(
          message,
          3
        );
        this.getActivityDetail(record.activityId);
        this.getBidList();
      })
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
  }
}
</script>
<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 200px;
    }

    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>

